/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Rep_Max_TitleInputs */

const en_us2_exercise_sheet_rep_max_title = /** @type {(inputs: Exercise_Sheet_Rep_Max_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your heaviest weight by reps`)
};

const pt_br2_exercise_sheet_rep_max_title = /** @type {(inputs: Exercise_Sheet_Rep_Max_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu peso máximo por repetições`)
};

const es_419_exercise_sheet_rep_max_title = /** @type {(inputs: Exercise_Sheet_Rep_Max_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu mayor peso por repeticiones`)
};

const pt_pt2_exercise_sheet_rep_max_title = /** @type {(inputs: Exercise_Sheet_Rep_Max_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu peso máximo por repetições`)
};

const fr_fr2_exercise_sheet_rep_max_title = /** @type {(inputs: Exercise_Sheet_Rep_Max_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta charge max selon les répétitions`)
};

const de_de2_exercise_sheet_rep_max_title = /** @type {(inputs: Exercise_Sheet_Rep_Max_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein höchstes Gewicht nach Wiederholungen`)
};

const it_it2_exercise_sheet_rep_max_title = /** @type {(inputs: Exercise_Sheet_Rep_Max_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo peso più alto per ripetizioni`)
};

/**
* | output |
* | --- |
* | "Your heaviest weight by reps" |
*
* @param {Exercise_Sheet_Rep_Max_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_rep_max_title = /** @type {((inputs?: Exercise_Sheet_Rep_Max_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Rep_Max_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_rep_max_title(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_rep_max_title(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_rep_max_title(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_rep_max_title(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_rep_max_title(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_rep_max_title(inputs)
	return en_us2_exercise_sheet_rep_max_title(inputs)
});
export { exercise_sheet_rep_max_title as "exercise-sheet.rep_max_title" }